import { useEffect, useState } from 'react';
import { firstInvalidFieldId } from './field-a11y';

/**
 * Returns a request to move focus to the first field with an error. A Save that
 * fails validation again would otherwise change nothing on screen and read as a
 * button that does not click. The focus waits until `busy` is false: a server
 * 400 arrives while the fields are still disabled, and a disabled field cannot
 * take focus. [HW-1008]
 */
export function useFocusFirstError<K extends string>(
  fields: readonly (readonly [K, string])[],
  errors: Partial<Record<K, string>>,
  busy: boolean
): () => void {
  const [requested, setRequested] = useState(false);
  useEffect(() => {
    if (!requested || busy) return;
    setRequested(false);
    const id = firstInvalidFieldId(fields, errors);
    if (id) document.getElementById(id)?.focus();
  }, [requested, busy, fields, errors]);
  return () => setRequested(true);
}
